/* Bundle Offer — quantity sync + nudge + price + image swap */
(function() {
  'use strict';

  var SINGLE_PRICE = 699;
  var BUNDLE_PRICE = 999;
  var bundleActive = false;

  function getQuantityInput() {
    return document.querySelector('.quantity-selector .quantity__input');
  }

  function getCards() {
    return document.querySelectorAll('.bundle-offer__card');
  }

  function formatINR(amount) {
    return '\u20B9' + amount.toLocaleString('en-IN');
  }

  function getCurrentVariant() {
    var checked = document.querySelector('input[data-single-option-selector][data-index="option1"]:checked');
    if (checked) return checked.value.toLowerCase().trim();
    return 'mocha';
  }

  function getBundleImageUrl() {
    var offer = document.getElementById('bundle-offer');
    if (!offer) return null;
    var variant = getCurrentVariant();
    if (variant.indexOf('assorted') > -1) return offer.getAttribute('data-bundle-img-assorted');
    if (variant.indexOf('hazelnut') > -1) return offer.getAttribute('data-bundle-img-hazelnut');
    return offer.getAttribute('data-bundle-img-mocha');
  }

  function getFirstSlideImg() {
    var slide = document.querySelector('.product__slide.media--active img');
    if (slide) return slide;
    return document.querySelector('.product__slide:first-child img');
  }

  function showBundleImage() {
    var img = getFirstSlideImg();
    if (!img) return;
    var bundleUrl = getBundleImageUrl();
    if (!bundleUrl) return;

    // Save originals if not already saved
    if (!img.getAttribute('data-original-src')) {
      img.setAttribute('data-original-src', img.getAttribute('src') || '');
      img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
    }
    img.setAttribute('src', bundleUrl);
    img.removeAttribute('srcset');
    bundleActive = true;
  }

  function restoreOriginalImage() {
    var img = getFirstSlideImg();
    if (!img) return;
    var origSrc = img.getAttribute('data-original-src');
    if (origSrc) {
      img.setAttribute('src', origSrc);
      var origSrcset = img.getAttribute('data-original-srcset');
      if (origSrcset) {
        img.setAttribute('srcset', origSrcset);
      }
      img.removeAttribute('data-original-src');
      img.removeAttribute('data-original-srcset');
    }
    bundleActive = false;
  }

  function setQuantity(val) {
    var input = getQuantityInput();
    if (!input) return;
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(input, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    updateUI(val);
  }

  function updateUI(qty) {
    qty = parseInt(qty, 10) || 1;

    // Update card selection
    var cards = getCards();
    cards.forEach(function(card) {
      var cardQty = parseInt(card.getAttribute('data-bundle-qty'), 10);
      if ((qty >= 2 && cardQty === 2) || (qty === 1 && cardQty === 1)) {
        card.classList.add('is-active');
      } else {
        card.classList.remove('is-active');
      }
    });

    // Update main price display
    var mainPriceEl = document.querySelector('.mMainPrice[data-product-price]');
    var strikePriceEl = document.querySelector('[data-compare-price]');
    var saleBadge = document.querySelector('[data-price-off]');
    if (mainPriceEl) {
      if (qty >= 2) {
        var bundlePairs = Math.floor(qty / 2);
        var remainder = qty % 2;
        var totalBundle = (bundlePairs * BUNDLE_PRICE) + (remainder * SINGLE_PRICE);
        var totalRegular = qty * SINGLE_PRICE;
        mainPriceEl.textContent = formatINR(totalBundle);
        mainPriceEl.classList.add('product__price--sale');
        if (strikePriceEl) {
          strikePriceEl.textContent = formatINR(totalRegular);
          strikePriceEl.style.display = '';
        }
        if (saleBadge) {
          var offBadge = saleBadge.querySelector('[data-price-off-badge]');
          var offAmount = saleBadge.querySelector('[data-price-off-amount]');
          if (offBadge && offAmount) {
            var pctOff = Math.round((1 - totalBundle / totalRegular) * 100);
            offAmount.textContent = pctOff + '%';
            offBadge.classList.remove('hidden');
          }
        }
      } else {
        mainPriceEl.textContent = formatINR(SINGLE_PRICE);
        if (strikePriceEl && !strikePriceEl.getAttribute('data-original-compare')) {
          strikePriceEl.setAttribute('data-original-compare', strikePriceEl.textContent.trim());
        }
        if (strikePriceEl) {
          var orig = strikePriceEl.getAttribute('data-original-compare') || '';
          if (orig) {
            strikePriceEl.textContent = orig;
            strikePriceEl.style.display = '';
          }
        }
        if (saleBadge) saleBadge.style.display = '';
      }
    }

    // Update nudge
    var nudgeEl = document.getElementById('bundle-nudge');
    if (nudgeEl) {
      if (qty === 1) {
        nudgeEl.className = 'bundle-nudge bundle-nudge--upsell';
        nudgeEl.innerHTML = 'Add 1 more to save \u20B9558 (\u20B9399 off + FREE Frother worth \u20B9159) \u2192';
      } else if (qty === 2) {
        nudgeEl.className = 'bundle-nudge bundle-nudge--active';
        nudgeEl.innerHTML = '\u2713 Bundle deal activated! You save \u20B9399 + get a Frother worth \u20B9159 FREE';
      } else {
        nudgeEl.className = 'bundle-nudge bundle-nudge--stock';
        nudgeEl.innerHTML = '\u2713 Frother included! Great choice stocking up';
      }
    }

    // Image swap
    if (qty >= 2) {
      showBundleImage();
    } else {
      restoreOriginalImage();
    }
  }

  function init() {
    // Card click handlers
    var cards = getCards();
    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        var targetQty = parseInt(card.getAttribute('data-bundle-qty'), 10);
        setQuantity(targetQty);
      });
    });

    // Quantity +/- handlers
    var input = getQuantityInput();
    if (input) {
      input.addEventListener('change', function() { updateUI(input.value); });
      input.addEventListener('input', function() { updateUI(input.value); });

      var minusBtn = document.querySelector('.quantity__minus');
      var plusBtn = document.querySelector('.quantity__plus');
      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          setTimeout(function() { updateUI(input.value); }, 50);
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          setTimeout(function() { updateUI(input.value); }, 50);
        });
      }
    }

    // Variant change handler — when flavor changes and bundle is active, update image
    var variantRadios = document.querySelectorAll('input[data-single-option-selector][data-index="option1"]');
    variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (bundleActive) {
          // Theme will swap image first, wait for it then re-apply bundle image
          setTimeout(function() {
            // Clear saved originals so we capture the new variant's image
            var img = getFirstSlideImg();
            if (img) {
              img.removeAttribute('data-original-src');
              img.removeAttribute('data-original-srcset');
            }
            // Wait a bit more for theme's image transition
            setTimeout(function() {
              showBundleImage();
            }, 300);
          }, 200);
        }
      });
    });

    // Default to 2-pack
    if (input && parseInt(input.value, 10) === 1) {
      setQuantity(2);
    } else {
      updateUI(input ? input.value : 2);
    }
  }

  /* --- Frother auto-add on bundle --- */
  var FROTHER_VARIANT_ID = 51418190086432;

  function interceptAddToCart() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      var qtyInput = getQuantityInput();
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (qty >= 2) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Get the main product variant id and quantity from the form
        var variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) { form.submit(); return; }

        // Add both items via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: parseInt(variantId, 10), quantity: qty },
              { id: FROTHER_VARIANT_ID, quantity: 1 }
            ]
          })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          // Trigger cart drawer or redirect
          var cartDrawerEvent = new CustomEvent('cart:added', { bubbles: true });
          form.dispatchEvent(cartDrawerEvent);

          // Also try to open the cart drawer the way the theme expects
          if (window.theme && window.theme.cart && window.theme.cart.getCart) {
            window.theme.cart.getCart();
          }
          // Fallback: fetch updated cart HTML and dispatch native event
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:build', { detail: cart }));
            // Final fallback: reload if drawer doesn't open within 500ms
            setTimeout(function() {
              var drawer = document.querySelector('.cart-drawer');
              if (drawer && !drawer.classList.contains('is-open') && !drawer.classList.contains('cart--active')) {
                window.location.href = '/cart';
              }
            }, 500);
          });
        })
        .catch(function() {
          // On error, just submit normally
          form.submit();
        });
      }
      // qty === 1: let the form submit normally (no frother)
    });
  }

  function init2() {
    init();
    interceptAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init2);
  } else {
    init2();
  }
})();
